$(document).ready(function ($) {
  $('form[action^="/cart/add"]').submit(function (e) {
      e.preventDefault();
      var form = $(this);
      var formData = form.serialize();

      var addToCartButton = form.find('button[type="submit"]');
      var buttonText = addToCartButton.find('span');

      // Show "Adding..." message and disable the button
      addToCartButton.prop('disabled', true);
      buttonText.text('Adding...');

      $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: formData,
          dataType: 'json',
          success: function (response) {
              // Update cart count
              updateCartCount();

              // Show success message
              buttonText.text('Added to Cart');

              // Open the cart drawer
              openCartDrawer();

              // Reset the button after 500ms
              setTimeout(function () {
                  buttonText.text('Add to Cart');
                  addToCartButton.prop('disabled', false);
              }, 500);
          },
          error: function () {
            //   buttonText.text('Add to Cart');
              addToCartButton.prop('disabled', false);
          }
      });
  });

  function updateCartCount() {
      $.getJSON('/cart.js', function (cart) {
          $('.cart_count').text(cart.item_count); // Update cart count on your cart icon
      });
  }

  function openCartDrawer() {
      $('.g_side_cart').addClass('active');
      $('body').addClass('no-scroll cart-open');
      $('.page-overlay').addClass('active');
  }

  // Close cart drawer functionality
  $('.close_cart').on('click', function () {
      $('.g_side_cart').removeClass('active');
      $('body').removeClass('no-scroll cart-open');
      $('.page-overlay').removeClass('active');
  });
});
